function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PureComponent } from "react";
import classnames from "classnames";
import { StyledLinkItemWithMenuComponent } from "./link-item-with-menu-component.scss";
import ArrowDown from "static/svg/arrow-down.svg";
import { withGenericConfig } from "contexts/generic-config-context";
import { generateOnKeyDownHandler } from "/client/services/accessibility/accessibility-service";
const LIST_ITEM_WITH_MENU_CLASS_NAME = "link-item-with-menu-component";
const HOVER_OPEN_MENU_WAIT_MILISECONDS = 500;
class LinkItemWithMenuComponent extends PureComponent {
    render() {
        const { title, isOpen, translate, className } = this.props;
        return /*#__PURE__*/ _jsxs(StyledLinkItemWithMenuComponent, {
            className: classnames(LIST_ITEM_WITH_MENU_CLASS_NAME, className, {
                "is-open": isOpen
            }),
            onKeyDown: this.onKeyDown,
            onClick: this.onClick,
            role: "link",
            tabIndex: 0,
            "aria-haspopup": "true",
            "aria-expanded": isOpen,
            children: [
                /*#__PURE__*/ _jsx("span", {
                    className: "link-item-with-menu-title",
                    children: translate(title)
                }),
                /*#__PURE__*/ _jsx(ArrowDown, {
                    className: "link-item-with-menu-icon"
                })
            ]
        });
    }
    constructor(props){
        super(props);
        _define_property(this, "onMouseLeave", (event)=>{
            const { isOpen, closeMenu } = this.props;
            this.clearHoverOpenMenuTimeoutIfNeeded();
            if (isOpen) {
                var _event_target;
                closeMenu(event);
                event === null || event === void 0 ? void 0 : (_event_target = event.target) === null || _event_target === void 0 ? void 0 : _event_target.blur();
            }
        });
        _define_property(this, "onMouseEnter", (event)=>{
            const { openMenu } = this.props;
            this._hoverTimeout = setTimeout(openMenu, this.getHoverWaitTime());
        });
        _define_property(this, "getHoverWaitTime", ()=>{
            const { shouldDelayMenuOpenOnHover } = this.props;
            return shouldDelayMenuOpenOnHover ? HOVER_OPEN_MENU_WAIT_MILISECONDS : 0;
        });
        _define_property(this, "clearHoverOpenMenuTimeoutIfNeeded", ()=>{
            if (this._hoverTimeout) {
                clearTimeout(this._hoverTimeout);
                this._hoverTimeout = null;
            }
        });
        _define_property(this, "onClickAction", (event)=>{
            const { openMenu, isOpen, closeMenu } = this.props;
            if (isOpen) {
                closeMenu();
            } else {
                openMenu();
            }
        });
        _define_property(this, "blurItem", (e)=>{
            var _e_target_closest, _e_target;
            e === null || e === void 0 ? void 0 : (_e_target = e.target) === null || _e_target === void 0 ? void 0 : (_e_target_closest = _e_target.closest(`.${LIST_ITEM_WITH_MENU_CLASS_NAME}`)) === null || _e_target_closest === void 0 ? void 0 : _e_target_closest.blur();
        });
        _define_property(this, "onClick", (e)=>{
            this.blurItem(e);
            this.onClickAction(e);
        });
        this.onKeyDown = generateOnKeyDownHandler(this.onClickAction);
        this._hoverTimeout = null;
    }
}
LinkItemWithMenuComponent.defaultProps = {
    shouldDelayMenuOpenOnHover: false
};
export default withGenericConfig(LinkItemWithMenuComponent);
